import {Button} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {ListControls} from '@/modules/hotels/components/List/components/ListControls';
import {useAppSelector} from '@/redux/config';
import {isNextPageLoading as getIsNextPageLoading} from '@/redux/v1/hotels/list/reducer';
import {testId} from '@/utils/testId';

type Props = {
  onClickLoadMore: () => void;
};

export const Footer: React.FunctionComponent<Props> = ({onClickLoadMore}) => {
  const {t} = useTranslation('hotels');
  const isNextPageLoading = useAppSelector(getIsNextPageLoading);

  return (
    <ListControls>
      <Button
        loading={isNextPageLoading}
        category="secondary"
        data-testid={testId('loadMoreButton')}
        onClick={onClickLoadMore}
      >
        {t('buttons.loadMore')}
      </Button>
    </ListControls>
  );
};
